import { useEffect } from "react";
import { LegalPage, LegalSection } from "@/components/LegalPage";

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacyverklaring | WanneerKaartverkoop.nl";
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalPage
      testid="privacy-page"
      eyebrow="Privacy"
      title="Privacyverklaring"
      intro="Laatst bijgewerkt: oktober 2026. Kort en duidelijk — zo hoort het."
    >
      <LegalSection title="Wie wij zijn">
        <p>
          WanneerKaartverkoop.nl helpt bezoekers ontdekken wanneer de kaartverkoop van festivals,
          concerten en andere events start. Vragen over deze verklaring? Mail{" "}
          <a href="mailto:info@wanneerkaartverkoop.nl" className="text-blaze hover:underline">info@wanneerkaartverkoop.nl</a>.
        </p>
      </LegalSection>
      <LegalSection title="Welke gegevens we verzamelen">
        <p>
          <strong className="text-white">Herinneringen:</strong> je e-mailadres en/of
          WhatsApp-nummer, plus het event waarvoor je een seintje wilt.{" "}
          <strong className="text-white">Contactformulier:</strong> je naam, e-mailadres en bericht.{" "}
          <strong className="text-white">Organisatoren:</strong> naam organisatie, e-mailadres en
          eventgegevens bij een aanmelding.
        </p>
      </LegalSection>
      <LegalSection title="Waarvoor we ze gebruiken">
        <p>
          Uitsluitend om je de gevraagde herinnering te sturen zodra een kaartverkoop start, en om
          je bericht te beantwoorden. Grondslag is je eigen toestemming. We sturen geen
          nieuwsbrieven of advertenties waar je niet expliciet om gevraagd hebt.
        </p>
      </LegalSection>
      <LegalSection title="Met wie we ze delen">
        <p>
          Alleen met onze verzenddiensten: Resend voor e-mail en Twilio voor WhatsApp-berichten.
          We verkopen of verhuren je gegevens nooit aan derden.
        </p>
      </LegalSection>
      <LegalSection title="Cookies en tracking">
        <p>
          We gebruiken <strong className="text-white">functionele cookies</strong> om de site
          goed te laten werken, zoals het onthouden van je voorkeuren. Daarnaast gebruiken we{" "}
          <strong className="text-white">tracking-cookies van onze affiliate-partners</strong>:
          klik je door naar een ticketpartner en doe je daar een aankoop, dan kan die partner
          via een cookie herkennen dat je via ons kwam. Wij ontvangen dan een kleine commissie —
          jij betaalt nooit meer.
        </p>
      </LegalSection>
      <LegalSection title="Hoe lang we ze bewaren">
        <p>
          Herinneringsgegevens tot de herinnering is verstuurd of tot je je uitschrijft.
          Contactberichten bewaren we maximaal 12 maanden.
        </p>
      </LegalSection>
      <LegalSection title="Jouw rechten">
        <p>
          Je mag je gegevens altijd inzien, laten corrigeren of verwijderen — een mailtje naar{" "}
          <a href="mailto:info@wanneerkaartverkoop.nl" className="text-blaze hover:underline">info@wanneerkaartverkoop.nl</a>{" "}
          is genoeg. Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
